export const AUTH_LOADING = "AUTH_LOADING";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const SIGNUP_ERROR = "SIGNUP_ERROR";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const UNAUTHORIZED_USER = "UNAUTHORIZED_USER";
export const FORBIDDEN_ACTION = "FORBIDDEN_ACTION";

export const CHECK_USER_EXIST_LOADING = "CHECK_USER_EXIST_LOADING";
export const CHECK_USER_EXIST_SUCCESS = "CHECK_USER_EXIST_SUCCESS";
export const CHECK_USER_EXIST_ERROR = "CHECK_USER_EXIST_ERROR";

export const GOOGLE_LOGIN_LOADING = "GOOGLE_LOGIN_LOADING";
export const GOOGLE_LOGIN_SUCCESS = "GOOGLE_LOGIN_SUCCESS";
export const GOOGLE_LOGIN_ERROR = "GOOGLE_LOGIN_ERROR";
export const NEW_USER_CREATED = "NEW_USER_CREATED";
export const VERIFICATION_REQUIRED = "VERIFICATION_REQUIRED";

export const SET_AUTH_REDUCER = "SET_AUTH_REDUCER";

export const LOGOUT_ERROR = "LOGOUT_ERROR";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";

export const GET_BASIC_SUCCESS = "GET_BASIC_SUCCESS";
export const GET_BASIC_ERROR = "GET_BASIC_ERROR";
export const SET_PROFILE_REDUCER = "SET_PROFILE_REDUCER";

export const DELETE_ACCOUNT_CHECK_LOADING = "DELETE_ACCOUNT_CHECK_LOADING";
export const DELETE_ACCOUNT_CHECK_SUCCESS = "DELETE_ACCOUNT_CHECK_SUCCESS";
export const DELETE_ACCOUNT_CHECK_ERROR = "DELETE_ACCOUNT_CHECK_ERROR";

export const DELETE_ACCOUNT_SUCCESS = "DELETE_ACCOUNT_SUCCESS";
export const DELETE_ACCOUNT_ERROR = "DELETE_ACCOUNT_ERROR";

export const CHECK_SESSION_SUCCESS = "CHECK_SESSION_SUCCESS";
export const CHECK_SESSION_ERROR = "CHECK_SESSION_ERROR";

export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR";
export const RESET_PASSWORD_INITIATE_SUCCESS =
  "RESET_PASSWORD_INITIATE_SUCCESS";
export const RESET_PASSWORD_INITIATE_ERROR = "RESET_PASSWORD_INITIATE_ERROR";
